import React, { useContext } from 'react';
import { IPhoneCall, PhoneSize } from './iphonecall';
import { PhoneLink } from '../link';
import context from '../../context/product/context';
import RichText from '../rich-text';
import { EventAction } from '../../../../services/ga';

const PhoneCall = ({ phoneNumber, size = PhoneSize.SHORT, className, text }: IPhoneCall) => {	
	const ctxt = useContext(context);

	if (!phoneNumber) {
		phoneNumber = ctxt.json.params.phoneNumber;
		if (!text && size === 'long') {
			text = `<span class='whitespace-nowrap'>${ctxt.json.params.brandPhoneDisplay}</span> <span class='whitespace-nowrap'>(${phoneNumber})</span>`;
		}
	}
	return (
		<PhoneLink phoneNumber={phoneNumber} action={EventAction.Phone}>
			<span className={className || 'font-bold text-brand'}>
				<RichText html={ text || phoneNumber } />
			</span>
		</PhoneLink>
	);
};

export default PhoneCall;
